import $ from 'jquery';
import Rellax from 'rellax';

$(document).ready(function () {
  // Accepts any class name
  // Also can pass in optional settings block
  var rellax = new Rellax('.rellax', {
    center: false,
    wrapper: null,
    round: true,
    vertical: true,
    horizontal: false,
  });
});

$(window).resize(function () {
});
